<!-- 配送方式管理 -->
<template>
    <el-form ref="form" :model="companyPage" label-width="100px" style="margin:0 20px">
        <el-row>
            <el-col :xs="24" :sm="18">
                <el-form-item :label="msg('配送方式')">
                    <el-input v-model.trim="companyPage.expCompany" :placeholder="msg('请输入配送方式，多个逗号分隔')" size="small"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="18">
                <el-form-item :label="msg('样式')">
                    <el-input v-model.trim="companyPage.qingGuan" :placeholder="msg('请输入样式')" size="small"></el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="18">
              <el-form-item :label="msg('设为默认')">
                  <el-checkbox v-model="companyPage.defaulted" :true-label="1" :false-label="0"></el-checkbox>
              </el-form-item>
            </el-col>
        </el-row>
        <div style="text-align:center; margin-top: 15px;">
            <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确认')}}</span></el-button>
            <el-button  size="mini" v-on:click="$emit('close-dg')">{{msg('取消')}}</el-button>
        </div>

    </el-form>

</template>

<script>

export default {
    name: "companyPageAdd",
    components:{

    },
    data(){
        return {
            options:null,
        }
    },
    mounted(){
    },
    props:{
        companyPage:Object,
    },
    methods:{
        init(){
        },
        onSubmit(){
            var _this = this;

            var url = this.$kit.api.expCompanyPage.create;

            this.$axios.post(url,this.companyPage)
                .then(function(result){
                  if (result.status) {
                    _this.$message.success(result.msg || _this.msg('添加成功'));
                    _this.$emit("close-dg", true);
                  } else {
                    _this.$message.error(result.msg || _this.msg('添加失败'));
                  }
                });
        },
    }

}
</script>

<style lang="scss" scoped>

</style>